import { render, staticRenderFns } from "./AppliesData.vue?vue&type=template&id=7c523198&"
import script from "./AppliesData.vue?vue&type=script&lang=js&"
export * from "./AppliesData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports